import React from 'react';

export const PipedriveScheduler: React.FC = () => {
  return (
    <iframe
      src='https://openpantry.pipedrive.com/scheduler/0Y9Zx9fa/open-pantry-enterprise-custom-chat'
      title='Pipedrive Scheduler Embed'
      height='600px'
      width='100%'
      style={{ width: '100%', border: 'none' }}
      allowFullScreen
    />
)};
